<template>
  <div id="userMessage">
    <van-nav-bar
      :fixed="true"
      :title="setpList[step]"
      left-arrow
      @click-left="goPre()"
      @click-right="goNext()"
      :right-text="setpList[step + 1]"
    >
    </van-nav-bar>
    <van-cell class="navi">
      <van-row>
        <!-- <van-col span="2" class="step"> </van-col> -->
        <van-col
          span="4"
          class="step"
          v-for="(v, i) in setpList"
          :key="i"
          :class="step >= i ? 'active' : 'disactive'"
        >
          <span @click="step = i"
            ><van-icon name="passed" v-if="step >= i" /> {{ i }}</span
          >
        </van-col>
      </van-row>
    </van-cell>
    <div id="context">
      
      <baseinfo
        v-if="step == 0"
        :info="useMessage"
        @handlerStep="handlerStep"
        @ShowCredentialType="ShowCredentialType"
        @showDatePup="ShowDatePup"
        @ShowArea="ShowArea"
        @ShowPopup="ShowPopup"
      ></baseinfo>

      <edu v-if="step == 1" :info="useMessage.eduList" @handlerStep="handlerStep">
      </edu>
      <awards
        v-if="step == 2"
        :info="useMessage.awardsList"
        @handlerStep="handlerStep"
        @ShowPopup="ShowPopup"
        @showDatePup="ShowDatePup"
      >
      </awards>

      <position
        v-if="step == 3"
        :info="useMessage.positionList"
        @handlerStep="handlerStep"
        @ShowPopup="ShowPopup"
        @showDatePup="ShowDatePup"
      >
      </position>
      <internship
        v-if="step == 4"
        :info="useMessage.internshipList"
        @handlerStep="handlerStep"
        @ShowPopup="ShowPopup"
        @showDatePup="ShowDatePup"
      >
      </internship>
      <selfevaluation
        v-if="step == 5"
        :info="useMessage"
        @handlerStep="handlerStep"
      ></selfevaluation>

      <!-- <div style="margin: 16px" v-if="step == 0">
        <van-row>
          <van-col span="8">
            <van-button round block @click.prevent="$router.back()"
              >取消</van-button
            >
          </van-col>
          <van-col span="8"> </van-col>
          <van-col span="8">
            <van-button round block @click.prevent="handlerStep(1)"
              >下一步</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div style="margin: 16px" v-else>
        <van-row>
          <van-col span="8"
            ><van-button round block @click.prevent="handlerStep(-1)"
              >上一步</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              round
              block
              @click.prevent="addData()"
              v-if="step < setpList.length - 1"
              >保存并新增</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              v-if="step == setpList.length - 1"
              round
              block
              type="info"
              native-type="submit"
              @click="onSubmit()"
              >提交</van-button
            >
            <van-button v-else round block @click.prevent="handlerStep(1)"
              >下一步</van-button
            >
          </van-col>
        </van-row>
      </div> -->
    </div>
    <!-- 地区选择弹窗 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @cancel="showArea = false"
        @confirm="onAreaConfirm"
      />
    </van-popup>

    <!-- 证件类型选择弹窗 -->
    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="pupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>

    <!-- 出生日期选择弹窗 -->
    <van-popup v-model="showDatePup" position="bottom">
      <van-datetime-picker
         type="date" format="yyyy-MM-dd"  value-format="yyyy-MM-dd" 
        title="出生日期"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showDatePup = false"
        @confirm="onDate"
      />
    </van-popup>
  </div>
</template>
<script>
import { area1 } from "@/utils/area";
import { resumeconfig } from "@/utils/resume";

import { Toast } from "vant";
import baseinfo from "./components/baseinfo";
import edu from "./components/edu";
import awards from "./components/awards";
import position from "./components/position";
import internship from "./components/internship";
import selfevaluation from "./components/selfevaluation";

export default {
  name: "userMessage",
  props: {},
  components: {
    baseinfo,
    edu,
    awards,
    position,
    internship,
    selfevaluation,
  },
  data() {
    return {
      showPopup: false,
      dataName: "",
      popupparam: "",
      setpList: [
        "基本信息",
        "教育背景",
        "获奖情况",
        "在校职务",
        "实习经验",
        "自我评价",
      ],
      id:"",
      step: 0,
      pupList: [],
      showArea: false,
      areaType: "",
      showCredential: false,
      showDatePup: false,
      dateFieldname: "",
      minDate: new Date(1960, 0, 1),
      maxDate: new Date(2002, 0, 1),
      pagetitle: "个人信息",
      nextTitle: "学习信息",
      resumeConfig: resumeconfig,
      areaList: area1,
      useMessage: {
        eduList: [],
        awardsList: [],
        internshipList: [],
        positionList: [],

      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    console.log( this.$route.params.id)
    if(this.id==""){
      $router.push('/jobs')
    }
    
  },
  methods: {
    ShowDatePup(dateFieldname) {
      this.showDatePup = true;
      this.dateFieldname = dateFieldname;
    },
    onDate(value) {
      let year = value.getFullYear();
      let month = value.getMonth() + 1;
      let day = value.getDate();
      let v = year + "年" + month + "月" + day + "日";
      this.$set(this.useMessage, this.dateFieldname, v);
      this.showDatePup = false;
    },
    ShowCredentialType() {
      this.showCredential = true;
    },

    onCredentialType(value) {
      console.log(value);
      this.$set(this.useMessage, "CredentialType", value);
      
      this.showCredential = false;
    },

    ShowPopup(name, param) {
      console.log(name, param);
      this.dataName = name;
      this.popupparam = param;
      this.pupList = eval("this.resumeConfig." + name);
      console.log(this.pupList);
      this.showPopup = true;
    },
    addData() {},
    onPopupConfirm(value) {
      console.log(value, this.dataName, this.popupparam);
      if (this.dataName == "意向工作地") {
        if (this.popupparam == "1") {
          this.$set(this.useMessage, "意向工作地一", value);
        } else {
          this.$set(this.useMessage, "意向工作地二", value);
        }
      } else {
        this.$set(this.useMessage, this.dataName, value);
      }

      this.showPopup = false;
    },

    ShowArea(name) {
      console.log(name);
      this.areaType = name;
      this.showArea = true;
    },
    onAreaConfirm(value) {
      let v = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");

      this.$set(this.useMessage, this.areaType, v);
      this.showArea = false;
    },

    // afterRead(file) {
    //   // 此时可以自行将文件上传至服务器
    //   console.log(file);
    // },
    onConfirm1(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
    },
    onChange(picker, value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      Toast("取消");
    },
    handlerStep(v) {
      var step = this.step + 1 * v;
      if (this.setpList.length == step) 
      {
        step = this.setpList.length - 1;
        this.onSubmit()
        return
      }
      if (step < 0) {
        this.$router.back();
        return;
      }

      this.step = step;
    },

    goNext() {
      this.step = this.step + 1;
      console.log(this.useMessage);
    },
    goPre() {
      if (this.step > 0) this.step = this.step - 1;
      else this.$router.back();
    },
    //提交信息
    onSubmit() {
      this.$request.resumeSave(this.useMessage).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "保存成功",
          });
          this.$router.back();
        } else {
          if (res.code == 2) {
            this.$toast({
              message: "电话已经存在",
            });
          }
        }
      });
      // this.restUseMessge();
    },
    //选择城市
    onConfirm(values) {
      this.useMessage.pcc = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("-");
      console.log(this.value);
      this.showArea = false;
    },
    //清空表单
    restUseMessge() {
      this.useMessage = {
        username: "",
        sex: "1",
        tel: "",
        pcc: "",
        detail: "",
        address: "",
      };
    },
  },
};
</script>
<style scoped lang="less">
.navi {
  position: fixed;
  top: 45px;
  z-index: 1;
}
.step {
  font-size: 10px;
  color: gray;
  text-align: center;
}
.active {
  color: darkgreen;
}
.disactive {
  color: gray;
}
#userMessage {
  box-sizing: border-box;
  padding: 10px;
  background: #fff;
}
#context {
  padding-top: 80px;
  padding-bottom: 64px;
}
</style>